// src/components/AIMito/index.tsx
import React, { useState } from 'react';
import './AIMito.css';
import ChatHeader from './ChatHeader';
import ChatInput from './ChatInput';
import ChatMessages from './ChatMessages';
import Suggestions from './Suggestions';
import FinancialDashboard from './FinancialDashboard';
import { useChat } from './useChat';
import OverlayWindow from 'Components/OverlayWindow';
import Button from 'Components/Buttons/Button';
import { QBOIcon } from 'assets/icons';
import BusinessSelectModal from 'app/features/services/addService/BusinessSelectModal';
import { useLazyGetServiceQuery } from 'app/services/payments/services';
import { useGetUserBusinessesQuery } from 'app/services/user';
import BatchCategorizationModal from './BatchCategorizationModal';
const AIMito = () => {
  const {
    messages,
    suggestions,
    loading,
    error,
    showHint,
    sendMessage,
    handleSuggestionClick,
    resetChat,
  } = useChat();

  // Determine if a financial report is available
  const financialReport = messages.find(
    (msg) =>
      msg.includes('Financial Insights') ||
      msg.includes('Report Type: BalanceSheet'),
  );

  // State to control dashboard popup visibility
  const [showDashboard, setShowDashboard] = useState(false);
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [targetServiceId, setTargetServiceId] = useState<number | null>(null);
  const [showCategorizer, setShowCategorizer] = useState(false);
  const [fetchService, { data: targetService }] = useLazyGetServiceQuery();
  const { data: businesses } = useGetUserBusinessesQuery();

  const handleServiceLinkClick = (id: number) => {
    setTargetServiceId(id);
    fetchService(id);
    setShowServiceModal(true);
  };

  const handleSelectBusiness = (businessId: number | null) => {
    if (!targetServiceId) return;
    const param = businessId === null ? 'null' : businessId;
    window.location.href = `/dashboard/services/add-service?service_id=${targetServiceId}&business_id=${param}&checkout=true`;
  };

  return (
    <div className="aimito-container">
      <div className="chat-container">
        <ChatHeader onReset={resetChat} />
        <ChatMessages
          messages={messages}
          error={error}
          showHint={showHint}
          loading={loading}
          suggestions={suggestions}
          onSuggestionClick={handleSuggestionClick}
          onServiceLinkClick={handleServiceLinkClick}
          onCategorizerClick={() => setShowCategorizer(true)}
        />
        <ChatInput sendMessage={sendMessage} loading={loading} />
        {!loading && (
          <Suggestions
            suggestions={suggestions}
            onClick={handleSuggestionClick}
          />
        )}

        {/* Render the "View Dashboard" button only if a financial report exists */}

        {financialReport && (
          <div className="p-2" style={{ textAlign: 'right' }}>
            {' '}
            <Button
              className="flex items-center gap-1"
              theme="green-outline"
              onClick={() => setShowDashboard(true)}
              title="View Financial Dashboard"
            >
              <QBOIcon className="h-4 w-4" />
              View Dashboard
            </Button>
          </div>
        )}

        {/* Dashboard Popup */}
        {showDashboard && financialReport && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            {/* The modal content container */}
            <div className="bg-white p-4 rounded shadow-lg max-w-md w-full relative">
              <FinancialDashboard report={financialReport} />

              <div className="text-right mt-2">
                <button
                  className="reset-button"
                  onClick={() => setShowDashboard(false)}
                  title="Close Dashboard"
                >
                  Close Dashboard
                </button>
              </div>
            </div>
          </div>
        )}

        {showServiceModal && targetService && businesses && (
          <BusinessSelectModal
            service={targetService}
            businesses={[
              { name: 'Personal', id: null },
              ...businesses.map((b) => ({ name: b.name, id: b.id })),
            ]}
            onSelect={handleSelectBusiness}
            onClose={() => setShowServiceModal(false)}
          />
        )}

        {showCategorizer && (
          <BatchCategorizationModal onClose={() => setShowCategorizer(false)} />
        )}
      </div>
    </div>
  );
};

export default AIMito;
